import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=6bea2bab&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=ts&"
export * from "./Main.vue?vue&type=script&lang=ts&"
import style0 from "./Main.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Main.vue?vue&type=style&index=1&id=6bea2bab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bea2bab",
  null
  
)

export default component.exports